import React from 'react';
import PropTypes from 'prop-types';

import { TEXT } from '../../locals';

const { MAIN } = TEXT;

const LearnMoreBtn = ({ theme, mainScreen }) => {
  const goToNextScreen = () => {
    window.scrollTo({
      top: mainScreen.current.clientHeight + 1, // +1 To make menu sticky.
      behavior: 'smooth',
    });
  };

  return (
    <div className="learn-more-block">
      <button
        className={theme.color}
        onClick={goToNextScreen}
        type="button"
      >
        <h5>{MAIN.BTN_LEARN_MORE}</h5>
      </button>
      <div className="arrows">
        <span />
        <span />
        <span />
      </div>
    </div>
  );
};

LearnMoreBtn.propTypes = {
  theme: PropTypes.instanceOf(Object).isRequired,
  mainScreen: PropTypes.instanceOf(Object).isRequired,
};

export default LearnMoreBtn;
